import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';

class UserRenderUnlistedCompetency extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
        	data: {
        		competencyName:'',
                competencyId: ''
        	}
    	};
    }

    handleUnlistedCompetencyView = (e, competencyName, competencyId) => {
        e.preventDefault()
        this.props.onhandleUnlistedCompetencyView(competencyName, competencyId)
    }
    render() {
        let handleUnlistedCompetencyView = this.handleUnlistedCompetencyView

    	return (
          		<GridCell span="4">
            		<Card style={{padding: '5px'}}>
                        <Grid>
                            <GridCell span="9">
                                <Typography> {this.props.competencyName} </Typography>
                            </GridCell>
                            <GridCell span="3">
                                <button className="mdc-button" align = "right" aria-label="Favorite" onClick= {((e) => handleUnlistedCompetencyView(e, this.props.competencyName, this.props.competencyId))}>View </button>
                            </GridCell>
                        </Grid>
                    </Card>
              	</GridCell>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRenderUnlistedCompetency);


// WEBPACK FOOTER //
// ./src/views/roadmap/UserRenderUnlistedCompetency.jsx